module.exports = __webpack_public_path__ + "img/1.a3441dc5.jpg";